<template>
  <div id="app">
    <!-- Inizio: Navigazione -->
    <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light">
      <div class="container">
        <a class="navbar-brand js-scroll" href="#top">
          <!-- HappyMenu -->
          <img src="img/logo-color.png" height="20px" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link js-scroll" href="#caratteristiche">Caratteristiche</a>
            </li>
            <li class="nav-item">
              <a class="nav-link js-scroll" href="#prezzi">Prezzi</a>
            </li>
            <li class="nav-item">
              <a class="nav-link js-scroll" href="#contatti">Contatti</a>
            </li>
            <li class="nav-item">
              <a class="nav-link highlight js-scroll" href="#" v-on:click="logIn()">Accedi</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- Fine: Navigazione -->

    <!-- Inizio: Header -->
    <header class="margin">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6 pt-0 pt-lg-5">
            <h1>Il tuo menu in un QR Code</h1>
            <h3>Nessuna App necessaria, nessun PDF da scaricare!</h3>
            <p>
              HappyMenu è l'alternativa professionale ed allo stesso tempo economica al vecchio menu di
              carta ed ai menu in PDF.
              La piattaforma ti permette di gestire il menu del tuo locale in totale autonomia e con estrema
              semplicità.
              <br />Puoi provare gratuitamente il prodotto per 30 giorni e se sei soddisfatto abbonarti ad uno dei nostri
              piani.
            </p>
            <!-- CTA -->
            <div class="text-center text-md-left mb-4 mt-4">
              <a
                class="btn btn-outline-primary js-scroll mr-2 mt-2"
                href="#caratteristiche"
              >Scopri di più</a>
              <a
                class="btn btn-primary js-scroll mr-2 mt-2"
                href="menu/demo"
                target="_blank"
              >Visualizza la Demo</a>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-5 offset-sm-0 offset-md-2 text-center mx-auto">
            <img src="img/header-img.png" class="img-fluid mt-4" />
          </div>
        </div>
      </div>
    </header>
    <!-- Fine: Header -->

    <!-- Inizio: Caratteristiche -->
    <section class="margin mt-5 mt-md-0" id="caratteristiche">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-12 text-center mx-auto">
            <h1>Caratteristiche</h1>
            <p>
              Scannerizza il QR Code per sfogliare il menu del locale direttamente dal browser.
              <br />HappyMenu è una piattaforma sviluppata utilizzando le più moderne tecnologie per garantire al cliente la miglior esperienza di utilizzo in totale semplicità.
            </p>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12 col-md-6 col-lg-4">
            <h3>Completezza</h3>
            <p>Gestione completa del menu del locale con testi, immagini, allergeni e rating dei piatti.</p>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <h3>Semplicità</h3>
            <p>Crea e modifica il menu con pochi click in qualsiasi momento da qualsiasi dispositivo.</p>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <h3>Personalizzazione</h3>
            <p>Inserisci il logo e il motto del locale per rendere il tuo menu unico.</p>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <h3>Promozione</h3>
            <p>Mostra gli eventi del tuo locale direttamente sul menu.</p>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <h3>
              Ecologico
              <span style="font-size: 18px; color: #a1cb86;">
                <i class="fas fa-leaf"></i>
              </span>
            </h3>
            <p>Non sprecare carta inutilmente! Il menu digitale aiuta a sostenere l'ambiente.</p>
          </div>
        </div>
      </div>
    </section>
    <!-- Fine: Caratteristiche -->

    <!-- Inizio: Banner -->
    <section class="margin banner">
      <div class="container">
        <div class="col-12 text-center">
          <h2>Sostituisci il tuo menu di carta, passa al digitale!</h2>
          <h5>Una scelta ecologica, igenica e al passo con i tempi che ti farà risparmiare sulla gestione del vecchio menu cartaceo.</h5>
          <p>
            Non sei ancora convinto?
            <a
              href="#perche"
              class="badge badge-pill badge-light js-scroll"
            >Scopri perchè</a> i nostri clienti hanno scelto HappyMenu.
          </p>
        </div>
      </div>
    </section>
    <!-- Fine: Banner -->

    <!-- Inizio: Perchè -->
    <section class="margin mt-4 mt-lg-0" id="perche">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6">
            <h1>Perchè scegliere HappyMenu?</h1>
            <p class="mt-3">
              A differenza di molti menu digitali che utilizzano file PDF (statico e di difficile lettura) HappyMenu viene visualizzato direttamente sullo smartphone tramite browser, adattandosi alla dimensione dello schermo.
              Questo permette al cliente di sfogliare il menu del locale senza non dover installare App o scaricare file sul proprio dispositivo.
              Inoltre semplifica al gestore del locale l'aggiornamento del proprio menu in qualsiasi momento ed in totale autonomia (prezzi, descrizioni, disponibilità, piatti del giorno).
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-6 mt-3 mt-md-0">
            <img src="img/feedback.png" class="img-fluid" />
          </div>
        </div>
      </div>
    </section>
    <!-- Fine: Perchè -->

    <!-- Inizio: Prezzi -->
    <section class="margin" id="prezzi">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-8 col-lg-8 mx-auto mb-3 text-center">
            <h1>Prezzi</h1>
            <p>
              Puoi provare la piattaforma in modo totalmente gratuito per 30 giorni e se sei soddisfatto abbornarti ad
              uno dei nostri piani.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card-deck mt-3 mb-3 text-center">
              <div class="card mb-4 box-shadow">
                <div class="card-header">
                  <h4 class="my-0 font-weight-normal">Demo</h4>
                </div>
                <div class="card-body">
                  <h1 class="card-title pricing-card-title">Free</h1>
                  <ul class="list-unstyled mt-3 mb-4">
                    <li>30 giorni di prova</li>
                    <li>Menu di esempio</li>
                    <li>QRCode non generabile</li>
                  </ul>
                  <a
                    href="#"
                    class="btn btn-lg btn-block btn-outline-primary js-scroll"
                    v-on:click="signIn()"
                  >Registrati</a>
                </div>
              </div>
              <div class="card mb-4 box-shadow">
                <div class="card-header">
                  <h4 class="my-0 font-weight-normal">Basic</h4>
                </div>
                <div class="card-body">
                  <h1 class="card-title pricing-card-title">
                    €9,90
                    <small class="text-muted">/ mese</small>
                  </h1>
                  <ul class="list-unstyled mt-3 mb-4">
                    <li>5 menu personalizzati</li>
                    <li>Tema a scelta</li>
                    <li>Rating piatti</li>
                  </ul>
                  <a href="#contatti" class="btn btn-lg btn-block btn-primary js-scroll">Contattaci</a>
                </div>
              </div>
              <div class="card mb-4 box-shadow">
                <div class="card-header">
                  <h4 class="my-0 font-weight-normal">Pro</h4>
                </div>
                <div class="card-body">
                  <h1 class="card-title pricing-card-title">
                    €19,90
                    <small class="text-muted">/ mese</small>
                  </h1>
                  <ul class="list-unstyled mt-3 mb-4">
                    <li>Menu illimitati</li>
                    <li>Promozione eventi</li>
                    <li>Assistenza</li>
                  </ul>
                  <a href="#contatti" class="btn btn-lg btn-block btn-primary js-scroll">Contattaci</a>
                </div>
              </div>
            </div>
            <p class="text-muted">* Tutti i prezzi sono Iva Esclusa</p>
          </div>
        </div>
      </div>
    </section>
    <!-- Fine: Prezzi -->

    <!-- Inizio: Contatti -->
    <section class="margin" id="contatti">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-8 mx-auto text-center">
            <h1>Contatti</h1>
            <h3>Hai bisogno di informazioni?</h3>
            <p>
              Utilizza il modulo sottostante per chiedere informazioni riguardo HappyMenu e tutti i suoi servizi.
              <br />Oppure contattaci allo
              <a href="tel:+390733290784">0733 290784</a>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6 mt-3 mb-4 mx-auto">
            <form id="mail-form">
              <input type="text" class="form-control" placeholder="Nome" v-model="nome" />
              <input type="email" class="form-control mt-2" placeholder="Email" v-model="email" />
              <textarea class="form-control mt-2" placeholder="Messaggio" v-model="messaggio"></textarea>
              <div class="invalid-feedback mb-2 text-left">
                <span v-for="(error, idx) in errors" :key="idx">{{ error }}</span>
              </div>
              <button
                type="button"
                class="btn btn-lg btn-block btn-primary mt-2"
                v-on:click="send()"
              >Invia</button>
              <div
                class="alert alert-success text-center mt-3"
                role="alert"
                v-if="sent"
              >Mail inviata correttamente, grazie per averci contattato :)</div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <!-- Fine: Contatti -->

    <!-- Inizio: Footer -->
    <footer class="margin">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <!-- Logo -->
            <img src="img/logo-white.png" height="30" />
            <!-- Social -->
            <div class="social mt-3">
              <a href="#" target="_blank" style="margin-left: 0;">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a href="#" target="_blank">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="#" target="_blank">
                <i class="fab fa-linkedin-in"></i>
              </a>
            </div>
            <!-- Copyright -->
            <p class="text-muted mt-2">
              HappyMenu è un prodotto di
              <a href="http://www.microdesign.it" target="_blank">
                Microdesign
                Srl
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
    <!-- Fine: Footer -->

    <CookiesAgreement />
  </div>
</template>

<script>
import axios from "axios";
import CookiesAgreement from "@/components/CookiesAgreement.vue";

export default {
  name: "Index",
  data: function () {
    return {
      piani: [],
      nome: "",
      email: "",
      messaggio: "",
      errors: [],
      sent: false,
    };
  },
  mounted: function () {
    //Recupero le info dei piani
    axios.get("BLS/api.php?getPiani").then((response) => {
      this.piani = JSON.parse(response.data.data).sort(function (a, b) {
        a.prezzo - b.prezzo;
      });
    });
  },
  methods: {
    signIn() {
      window.location.href = "account.html#/signin";
    },
    logIn() {
      window.location.href = "account.html#/login";
    },
    send() {
      this.errors = [];

      if (this.nome.isEmpty()) this.errors.push("Inserire un nome valido");
      if (
        this.email.isEmpty() ||
        !/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.email
        )
      )
        this.errors.push("Inserire una mail valida");
      if (this.messaggio.isEmpty())
        this.errors.push("Inserire il corpo del messaggio");

      //Se non ci sono errori
      if (this.errors.length == 0) {
        //Invio la mail
        axios
          .post("BLS/api.php?mailSend", {
            to: "fpalessandro@microdesign.it",
            subject: "happymenu.it: Mail da " + this.nome,
            body: this.messaggio + "\r\n" + this.email,
          })
          .then((response) => {
            console.log(response);
            if (response.data.status < 1) throw response.data.message;
            this.sent = true;
            this.nome = "";
            this.email = "";
            this.messaggio = "";
          })
          .catch((error) => {
            this.errors.push(error);
          });
      }
    },
  },
  components: {
    CookiesAgreement,
  },
};
</script>

<style>
/* Tipografia */
h1 {
  font-size: 38px;
}

h5,
p {
  color: rgb(100, 100, 100);
}

/* Layout */
.nav-link.highlight {
  color: var(--theme-color-primary) !important;
  font-weight: 500;
}

header {
  padding-top: 100px;
  background-position: left bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

header img {
  height: 400px;
}

header h3 {
  font-weight: 400;
}

@media (min-width: 992px) {
  header {
    background-position: right top;
    background-image: url("/img/sfondo.png");
  }

  header img {
    height: 500px;
  }
}

@media (min-width: 1200px) {
  header {
    height: 100vh;
  }

  header img {
    height: 600px;
  }
}

.banner {
  background-image: url("/img/banner.jpg");
  background-size: cover;
  background-position: center center;
  color: #fff;
}

.banner h2 {
  margin-top: 10px;
  font-size: 35px;
}

.banner h5,
.banner p {
  color: #fff;
}

.banner .badge-light,
.banner .badge-light:hover,
.banner .badge-light:focus {
  font-size: 16px;
  font-weight: 400;
  color: #000;
}

@media (min-width: 768px) {
  .banner {
    background-attachment: fixed;
  }

  .banner h2 {
    margin-top: 20px;
    font-size: 46px;
  }
}

.invalid-feedback {
  display: block;
}

.invalid-feedback span {
  display: block;
}

footer .social a {
  color: rgb(187, 187, 187) !important;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
